class AbstractMidi {
}

export default AbstractMidi;
